import { ComponentType } from 'react';
import { IconProps } from '@drift-labs/icons';
import { cm } from 'src/utils/classNames';
import { WithChildren } from 'src/utils/UtilityTypes';

export interface TagProps extends WithChildren {
	/**
	 * You need to set the bg and text color.
	 */
	className: string;
	leftIcon?: ComponentType<IconProps>;
	rightIcon?: ComponentType<IconProps>;
}

export default function Tag({
	className,
	children,
	leftIcon: LeftIcon,
	rightIcon: RightIcon,
}: TagProps) {
	return (
		<div
			className={cm(
				'flex items-center gap-x-2xs rounded-xs px-xs py-2xs typo-b5',
				className
			)}
		>
			{LeftIcon && <LeftIcon size={12} />}
			{children}
			{RightIcon && <RightIcon size={12} />}
		</div>
	);
}
